
import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../_core/_services/notification.service';
import { SupportService } from '../../../_core/_services/support/support.service';
import { SupportTicketListItemDto } from '../../../_core/_model/support/support';

@Component({
  selector: 'app-support-tickets',
  standalone: false,
  templateUrl: './support-tickets.html',
  styleUrl: './support-tickets.css'
})
export class SupportTickets implements OnInit {
  loading = false;
  tickets: SupportTicketListItemDto[] = [];

  constructor(
    private supportService: SupportService,
    private notifyService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadTickets();
  }

  loadTickets(): void {
    this.loading = true;

    this.supportService.getMyTickets().subscribe({
      next: (res) => {
        this.tickets = res.data || [];
      },
      error: (err) => {
        this.tickets = [];
        this.notifyService.showError(
          err?.error?.message || 'Failed to load tickets',
          'Error'
        );
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}